module.exports = __webpack_public_path__ + "img/shop3_1.ca28dc93.png";